import type Variant from '../type/variant';

export const useSampleStock = (
    variant: Variant | null,
): {
    canPurchase: boolean;
    quantityLimit: number;
    priceText: string;
} => {
    const canPurchase = Boolean(
        variant &&
        variant.SampleEnabled &&
        variant.AvailableSampleStock > 0 &&
        variant.ProjectedSamplePrice &&
        variant.ProjectedSamplePrice.Amount >= 0,
    );

    const priceText = variant
        ? variant.ProjectedSamplePrice?.Amount === 0
            ? 'Free'
            : (variant.ProjectedSamplePrice?.ShortFormat.replace('.00', '') ??
              '')
        : '';

    return {
        canPurchase,
        priceText,
        quantityLimit:
            canPurchase && variant ? variant.AvailableSampleStock : 0,
    };
};
